module.exports = __webpack_public_path__ + "img/image6.b6ae1f61.png";